import config from 'utils/config';

const PFP_PATH = '/v1/social/generated_profile_image';
const DEFAULT_SEED = 'kalshi';
const DEFAULT_SIZE = 512;

const normalizeSeed = (seed: string | null | undefined): string => (seed ?? '').trim() || DEFAULT_SEED;

export function getGeneratedProfileImageUrl(seed: string, shuffleIndex = 0, size = DEFAULT_SIZE): string {
    const params = new URLSearchParams({
        shuffle_index: String(Math.max(0, Math.floor(shuffleIndex))),
        size: String(size),
        seed: normalizeSeed(seed),
    });
    return `${config.exchangeApiUrl}${PFP_PATH}?${params.toString()}`;
}

export function getProfilePictureProxyUrl(nickname: string): string {
    return `/api-app/pfp/${encodeURIComponent(normalizeSeed(nickname))}`;
}

const GENERATED_PATH_PATTERN = /-generated-(\d+)-\d+$/;

export function shuffleIndexFromProfileImagePath(path: string | null | undefined): number | null {
    const match = path?.trim().match(GENERATED_PATH_PATTERN);
    if (!match) return null;
    const idx = parseInt(match[1], 10);
    return Number.isFinite(idx) && idx >= 0 ? idx : null;
}
